import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:8786/api`;

function UsersPage() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [formData, setFormData] = useState({ username: '', password: '', name: '', role: 'USER' });
  const [showAttendanceMenu, setShowAttendanceMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const name = localStorage.getItem('name');
    
    if (!token) {
      navigate('/login');
      return;
    }

    setCurrentUser({ role, name });
    fetchUsers(token);
  }, [navigate]);

  const fetchUsers = async (token) => {
    try {
      const response = await axios.get(`${API_URL}/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response?.status === 401) {
        localStorage.clear();
        navigate('/login');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      await axios.post(`${API_URL}/users`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFormData({ username: '', password: '', name: '', role: 'USER' });
      setShowForm(false);
      fetchUsers(token);
    } catch (error) {
      alert(error.response?.data || 'Error creating user');
    }
  };

  const toggleUserStatus = async (userId) => {
    const token = localStorage.getItem('token');
    try {
      await axios.put(`${API_URL}/users/${userId}/toggle`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchUsers(token);
    } catch (error) {
      alert(error.response?.data || 'Error toggling user status');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const canCreateRole = (role) => {
    if (currentUser?.role === 'MASTER') return role !== 'MASTER';
    if (currentUser?.role === 'ADMIN') return role === 'USER' || role === 'VERIFIER';
    return false;
  };

  const canToggle = (user) => {
    if (user.role === 'MASTER') return false;
    if (currentUser?.role === 'MASTER') return true;
    if (currentUser?.role === 'ADMIN' && (user.role === 'USER' || user.role === 'VERIFIER')) return true;
    return false;
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <div style={{ width: '250px', backgroundColor: '#f8f9fa', borderRight: '1px solid #dee2e6', padding: '20px' }}>
        <div style={{ marginBottom: '30px', textAlign: 'center' }}>
          <img src="/misk_logo.png" alt="MISK Logo" style={{ height: '60px' }} />
        </div>
        <nav>
          <div 
            style={{ padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px' }}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            📊 Dashboard
          </div>
          <div 
            style={{ padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px' }}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            👥 Students
          </div>
          {(currentUser?.role === 'ADMIN' || currentUser?.role === 'MASTER') && (
            <div 
              style={{ padding: '12px', cursor: 'pointer', borderRadius: '5px', backgroundColor: '#e8f5e9', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px' }}
            >
              👤 Users
            </div>
          )}
          {(currentUser?.role === 'ADMIN' || currentUser?.role === 'MASTER') && (
            <div style={{ marginBottom: '10px' }}>
              <div 
                style={{ padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500' }}
                onClick={() => setShowAttendanceMenu(!showAttendanceMenu)}
              >
                📋 Attendance {showAttendanceMenu ? '▼' : '▶'}
              </div>
              {showAttendanceMenu && (
                <>
                  <div 
                    style={{ paddingLeft: '30px', paddingTop: '8px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555' }}
                    onClick={() => navigate('/attendance-sheet')}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    Generate Sheet
                  </div>
                  <div 
                    style={{ paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555' }}
                    onClick={() => navigate('/upload-attendance')}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    Upload Offline Sheet
                  </div>
                  <div 
                    style={{ paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555' }}
                    onClick={() => navigate('/online-attendance')}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    Online Attendance
                  </div>
                </>
              )}
            </div>
          )}
        </nav>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)', padding: '20px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h1 style={{ color: 'white', margin: 0 }}>User Management</h1>
            <div>
              <button onClick={() => setShowForm(!showForm)} style={{ padding: '10px 20px', marginRight: '10px', background: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                {showForm ? 'Cancel' : 'Create User'}
              </button>
              <button onClick={handleLogout} style={{ padding: '10px 20px', background: '#666', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                Logout
              </button>
            </div>
          </div>

          {showForm && (
            <div style={{ background: 'white', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
              <h2>Create New User</h2>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Username *</label>
                  <input type="text" value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} required style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }} />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Password *</label>
                  <input type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }} />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Name *</label>
                  <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }} />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Role *</label>
                  <select value={formData.role} onChange={(e) => setFormData({ ...formData, role: e.target.value })} style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ddd' }}>
                    {canCreateRole('USER') && <option value="USER">USER</option>}
                    {canCreateRole('ADMIN') && <option value="ADMIN">ADMIN</option>}
                    {canCreateRole('VERIFIER') && <option value="VERIFIER">VERIFIER</option>}
                  </select>
                </div>
                <button type="submit" style={{ padding: '10px 30px', background: '#2d5f3f', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                  Create User
                </button>
              </form>
            </div>
          )}

          <div style={{ background: 'white', borderRadius: '10px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#2d5f3f', color: 'white' }}>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Username</th>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Name</th>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Role</th>
                  <th style={{ padding: '15px', textAlign: 'center' }}>Status</th>
                  <th style={{ padding: '15px', textAlign: 'center' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id} style={{ borderBottom: '1px solid #ddd' }}>
                    <td style={{ padding: '15px' }}>{user.username}</td>
                    <td style={{ padding: '15px' }}>{user.name || '-'}</td>
                    <td style={{ padding: '15px' }}>
                      <span style={{ padding: '5px 10px', borderRadius: '5px', background: user.role === 'MASTER' ? '#ff9800' : user.role === 'ADMIN' ? '#2196F3' : user.role === 'VERIFIER' ? '#9C27B0' : '#4CAF50', color: 'white', fontSize: '12px' }}>
                        {user.role}
                      </span>
                    </td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>
                      <span style={{ padding: '5px 10px', borderRadius: '5px', background: user.enabled ? '#4CAF50' : '#f44336', color: 'white', fontSize: '12px' }}>
                        {user.enabled ? 'Enabled' : 'Disabled'}
                      </span>
                    </td>
                    <td style={{ padding: '15px', textAlign: 'center' }}>
                      {canToggle(user) && (
                        <button onClick={() => toggleUserStatus(user.id)} style={{ padding: '8px 15px', background: user.enabled ? '#f44336' : '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                          {user.enabled ? 'Disable' : 'Enable'}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsersPage;
